import React from "react";
import PropTypes from "prop-types";

import Hidden from "core/Hidden";

import CircleButton from "core/CircleButton";
import Person from "core/ReusableIcons/Person";
import Edit from "core/ReusableIcons/Edit";

import breakpoints from "core/breakpoints";
import { FortLinksContainer } from "./styles";

import { useViewport } from "js/hooks/useViewport";

const FortLinks = ({ isSuperuser, iconId, creatorId }) => {
    if (!isSuperuser) return null;

    const { browserWidth } = useViewport();
    const isDesktop = browserWidth > breakpoints.beforeDesktop.px;

    const styleType = isDesktop ? "primary" : "cta";

    return (
        <Hidden breakpoint="sm">
            <FortLinksContainer>
                <CircleButton
                    href={`/fort/icon/${iconId}/`}
                    target="_blank"
                    size="sm"
                    title="Open icon in fort"
                    icon={<Edit size="sm" />}
                    styleType={styleType}
                    darkMode
                />
                <CircleButton
                    href={`/fort/members/${creatorId}/`}
                    target="_blank"
                    size="sm"
                    title="Open icon's creator profile in fort"
                    icon={<Person size="sm" />}
                    styleType={styleType}
                    darkMode
                />
            </FortLinksContainer>
        </Hidden>
    );
};

FortLinks.propTypes = {
    isSuperuser: PropTypes.bool.isRequired,
    creatorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
};

export default FortLinks;
